import createComponent from '../create-component';
export default createComponent([["title",{"key":"svg-title"}],["rect",{"width":"248","height":"248","fill":"#3164fa","rx":"124","key":"svg-rect"}],["g",{"fill":"#fff","key":"svg-g"}]]);